import { Radio } from 'antd';
import styled from 'styled-components';

export const StyledRadioGroup = styled(Radio.Group)`
  .ant-radio-wrapper-checked .ant-radio-inner {
    border-color: ${({ theme }) => theme.colors.primary[100]} !important;
    background-color: ${({ theme }) => theme.colors.primary[100]};
  }
`;
